import { ajaxSend } from '../../../api/api';

const basePath = '/v1/integrations/email';

export function getEmail(
  payload: { email: string } | null = null,
): ReturnType<typeof ajaxSend> | undefined {
  if (payload === undefined || payload === null) {
    console.error('getEmail - No valid payload given.');
    return undefined;
  }

  const { email } = payload;

  if (typeof email !== 'string') {
    console.error('getEmail - No valid payload given.');
    return undefined;
  }

  return ajaxSend({
    path: `${basePath}/${email}`,
  });
}

export function flowGetAll(
  payload: { channel: string } = { channel: 'email' },
) {
  const { channel } = payload;
  return ajaxSend({
    path: `/v1/flows?channel=${channel}`,
  });
}

export function flowDelete(payload: { id: string }) {
  const { id } = payload;
  return ajaxSend({
    method: 'DELETE',
    path: `/v1/flows/${id}`,
  });
}

export function getEmailList() {
  return ajaxSend({
    path: `${basePath}`,
  });
}

export function deleteEmail(
  payload: { email: string } | null = null,
): ReturnType<typeof ajaxSend> | undefined {
  if (payload === undefined || payload === null) {
    console.error('deleteEmail - No valid payload given.');
    return undefined;
  }

  const { email } = payload;

  if (typeof email !== 'string') {
    console.error('deleteEmail - No valid payload given.');
    return undefined;
  }

  return ajaxSend({
    method: 'DELETE',
    path: `${basePath}/${email}`,
  });
}

export function addEmail(
  payload: {
    identifier: string;
    sender_name: string | null;
    signature_template: string | null;
  } | null = null,
): ReturnType<typeof ajaxSend> | undefined {
  if (!payload) {
    console.error('addEmail - No valid payload given.');
    return undefined;
  }

  const { identifier, sender_name, signature_template } = payload;

  if (typeof identifier !== 'string') {
    console.error('addEmail - No valid payload given.');
    return undefined;
  }

  const data: {
    identifier: string;
    signature_template?: string;
    sender_name?: string;
  } = {
    identifier: identifier,
  };

  if (
    signature_template &&
    signature_template.trim() !== '' &&
    signature_template.trim() !== '<p></p>' &&
    signature_template.trim() !== '<p>&nbsp;</p>'
  ) {
    data.signature_template = signature_template;
  }

  if (sender_name && typeof sender_name === 'string') {
    data.sender_name = sender_name;
  }

  return ajaxSend({
    method: 'POST',
    path: `${basePath}`,
    data: data,
  });
}

export function updateEmail(
  payload: {
    email: string;
    queue_id: string;
    sender_name: string | null;
    signature_template: string | null;
  } | null = null,
): ReturnType<typeof ajaxSend> | undefined {
  if (payload === undefined || payload === null) {
    console.error('updateEmail - No valid payload given.');
    return undefined;
  }

  const { email, sender_name, signature_template } = payload;

  if (typeof email !== 'string') {
    console.error('updateEmail - No valid payload given.');
    return undefined;
  }

  const data: {
    updates: Partial<{ sender_name: string; signature_template: string }>;
    deletes: string[];
  } = {
    updates: {},
    deletes: [],
  };

  if (
    sender_name !== undefined &&
    sender_name !== null &&
    sender_name.trim() !== ''
  ) {
    data.updates.sender_name = sender_name;
  } else {
    data.deletes.push('sender_name');
  }

  if (
    signature_template &&
    signature_template.trim() !== '' &&
    signature_template.trim() !== '<p></p>' &&
    signature_template.trim() !== '<p>&nbsp;</p>'
  ) {
    data.updates.signature_template = signature_template;
  } else {
    data.deletes.push('signature_template');
  }

  return ajaxSend({
    method: 'PATCH',
    path: `${basePath}/${email}`,
    data: data,
  });
}
